import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d2ac2502")

_pushScopeId("data-v-d2ac2502")
const _hoisted_1 = { class: "dialog-overlay" }
const _hoisted_2 = { class: "dialog-display-area" }
const _hoisted_3 = { class: "dialog-box" }
const _hoisted_4 = { class: "dialog-box-title" }
const _hoisted_5 = { class: "dialog-box-title-text" }
const _hoisted_6 = { class: "dialog-box-contents" }
const _hoisted_7 = { class: "dialog-box-contents-contents" }
const _hoisted_8 = {
  key: 0,
  class: "dialog-box-contents-contents-quickbutton"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "dialog-box-contents-contents-quickbutton-separator" }, [
  /*#__PURE__*/_createVNode("div", { class: "dialog-box-contents-contents-quickbutton-separator-line" })
], -1)
const _hoisted_10 = { class: "dialog-box-contents-contents-quickbutton-title" }
const _hoisted_11 = { class: "dialog-box-contents-contents-quickbutton-title-text" }
const _hoisted_12 = {
  key: 1,
  class: "dialog-box-contents-contents-afterquickbutton"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "dialog-box-contents-contents-afterquickbutton-separator" }, [
  /*#__PURE__*/_createVNode("div", { class: "dialog-box-contents-contents-afterquickbutton-separator-line" })
], -1)
const _hoisted_14 = { class: "dialog-box-contents-contents-footer" }
const _hoisted_15 = { class: "dialog-box-contents-contents-footer-text" }
const _hoisted_16 = { class: "dialog-box-bottom" }
const _hoisted_17 = { class: "dialog-box-bottom-negative-text" }
const _hoisted_18 = { class: "dialog-box-bottom-positive-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FridgeDetailsConfirmSettingsDialogItem = _resolveComponent("FridgeDetailsConfirmSettingsDialogItem")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_Transition, { name: "dialog" }, {
      default: _withId(() => [
        _withDirectives(_createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("span", _hoisted_5, _toDisplayString(_ctx.displayTitle), 1)
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.displayItemList, (item) => {
                    return (_openBlock(), _createBlock(_component_FridgeDetailsConfirmSettingsDialogItem, {
                      key: item.index,
                      itemName: item.itemName,
                      itemValue: item.value
                    }, null, 8, ["itemName", "itemValue"]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  (_ctx.displayQuickButtonItemList.length>0)
                    ? (_openBlock(), _createBlock("div", _hoisted_8, [
                        _hoisted_9,
                        _createVNode("div", _hoisted_10, [
                          _createVNode("span", _hoisted_11, _toDisplayString(_ctx.quickButtonTitle), 1)
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.displayQuickButtonItemList, (item) => {
                          return (_openBlock(), _createBlock(_component_FridgeDetailsConfirmSettingsDialogItem, {
                            key: item.index,
                            itemName: item.itemName,
                            itemValue: item.value
                          }, null, 8, ["itemName", "itemValue"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.displayAfterQuickButtonItemList.length>0)
                    ? (_openBlock(), _createBlock("div", _hoisted_12, [
                        _hoisted_13,
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.displayAfterQuickButtonItemList, (item) => {
                          return (_openBlock(), _createBlock(_component_FridgeDetailsConfirmSettingsDialogItem, {
                            key: item.index,
                            itemName: item.itemName,
                            itemValue: item.value
                          }, null, 8, ["itemName", "itemValue"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_14, [
                    _createVNode("span", _hoisted_15, _toDisplayString(_ctx.footerText), 1)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_16, [
                _createVNode("div", {
                  class: "dialog-box-bottom-negative",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelClicked(...args)))
                }, [
                  _createVNode("div", _hoisted_17, _toDisplayString(_ctx.cancelText), 1)
                ]),
                _createVNode("div", {
                  class: "dialog-box-bottom-positive",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sendClicked(...args)))
                }, [
                  _createVNode("div", _hoisted_18, _toDisplayString(_ctx.sendText), 1)
                ])
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.isShowDialog]
        ])
      ]),
      _: 1
    })
  ]))
})